<script lang="ts">
    import { afterNavigate, beforeNavigate } from '$app/navigation';
    import { page } from '$app/stores';
    import { get } from 'svelte/store';
    import { onMount } from 'svelte';
    import ROUTE_IDS from '$src/generated/routeIds';
    import { spineBus } from '$src/lib/services/gatekeeper/MessageBus';
    import { MARKET_SLUGS } from '$src/lib/services/market/slugs';
    import { getRoute, previousUrl } from '$src/lib/services/navigation';

    beforeNavigate(({ from, to, cancel }) => {
        if (from?.url) {
            previousUrl.set(new URL(from.url));
        }

        const normalisedTo = to?.url.pathname.replace(/\/$/, '');
        const registrationRoute = getRoute(ROUTE_IDS.REGISTER);

        spineBus.publish('navigation', {
            kind: 'changing',
            from: from?.url,
            to: to?.url
        });

        if (
            registrationRoute &&
            normalisedTo === registrationRoute &&
            $page.data.market.slug !== MARKET_SLUGS.ON
        ) {
            cancel();
            spineBus.publish('registration', { kind: 'start' });
        }
    });

    afterNavigate(({ from, to }) => {
        spineBus.publish('navigation', {
            kind: 'changed',
            from: from?.url,
            to: to?.url
        });
    });

    onMount(() => {
        spineBus.publish('spine', {
            kind: 'loaded',
            isLoggedIn: get(page).data.isLoggedIn
        });
    });
</script>
